import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import { getExamslistByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getInterviewPostPrefList } from "../../actions/interviewProcessActions";
import {
  getYearList,
  getMainsAdvertisements,
} from "../../../common/actions/commonActions";
import { SET_INTERVIEW_POST_PREFERENCE_LIST } from "../../../common/constants/ActionTypes";
import moment from "moment";

const InterviewPostPreferencesList = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    setReloadItem(!reloadItem);
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { getInterviewPostPreferenceList } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSaveButtonFlag(false);
    setConfirmClicked(false);
    setPrintFlag(true);
    dispatch({
      type: SET_INTERVIEW_POST_PREFERENCE_LIST,
      payload: [],
    });
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getMainsAdvertisements(selectedValue));
      if (getMainsAdvertisement) {
        getMainsAdvertisement.length = 0;
      }
      dispatch({
        type: SET_INTERVIEW_POST_PREFERENCE_LIST,
        payload: [],
      });
      setSaveButtonFlag(true);
      setPrintFlag(true);
      setReloadItem(!reloadItem);
    }
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    dispatch({
      type: SET_INTERVIEW_POST_PREFERENCE_LIST,
      payload: [],
    });
  };

  const onSubmit = () => {
    dispatch(getInterviewPostPrefList(selectedAdvertNo, setPrintFlag));
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
      label.MPSC +
      "</h5><h5>" +
      getInterviewPostPreferenceList.advertisementName +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "Interview_Post_Pref_List.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = getInterviewPostPreferenceList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);

          const headerText1 = label.MPSC;
          const headerX1 = pdf.internal.pageSize.width / 2;
          const headerY1 = 0.6;

          pdf.setFontSize(10);
          pdf.text(headerText1, headerX1, headerY1, { align: "center" });

          const headerText2 = getInterviewPostPreferenceList.advertisementName;
          const headerX2 = pdf.internal.pageSize.width / 2;
          const headerY2 = 0.8;

          pdf.setFontSize(10);
          pdf.text(headerText2, headerX2, headerY2, { align: "center" });

          const headerText3 = "POST CHOICE AND PREFERENCES BY CANDIDATES";
          const headerX3 = pdf.internal.pageSize.width / 2;
          const headerY3 = 1.0;

          pdf.setFontSize(10);

          pdf.text(headerText3, headerX3, headerY3, { align: "center" });
        }

        pdf.save(`Interview_Post_Pref_List.pdf`);
      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };

  return (
    <div>
      <h5> {label.InterviewPostPreferencesList} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    value={selectedYear}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option key={index}>{element}</option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo1"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo1.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <>
                        {" "}
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag}
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                            setConfirmClicked(true);
                          })}
                        >
                          {commonLabels.BUTTON_VIEW}
                        </button>
                      </>
                    )}
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={printFlag || !confirmClicked}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div ref={pdfRef} className="answerKeyTable" id="cutOff">
        {getInterviewPostPreferenceList &&
          getInterviewPostPreferenceList.interviewListTokenDtos &&
          getInterviewPostPreferenceList.interviewListTokenDtos.length > 0 &&
          getInterviewPostPreferenceList.interviewListTokenDtos.map((item, index) => (
            <div className="no-page-break mb-4">
              <div className="">
                <label className="font-weight-bold mr-2">Center Name:</label>
                <span className="font-weight-bold mr-3">
                  {item.interviewCenterName}
                </span>
                <br />
                <label className="font-weight-bold mr-2">Interview Date:</label>
                <span className="font-weight-bold mr-3">
                  {/* {new Date(item.interviewDate.substring(0, 10)).toLocaleDateString('en-GB')} */}
                  {moment(item.interviewDate).format('DD/MM/YYYY')}
                </span>
                <br />
                <label className="font-weight-bold mr-2">Committee:</label>
                <span className="font-weight-bold mr-3">
                  {item.committee}
                </span>
              </div>
              <table className="table text-center">
                <thead className="bold-label">
                  <tr>
                    <th id="topbotborder" className="w-100px">{label.TokenNo}</th>
                    <th id="topbotborder" className="text-left">Preference and Post</th>
                  </tr>
                </thead>
                <tbody>
                  {item.interviewScheduleDto.map((schedule, scheduleIndex) => (
                    <tr key={scheduleIndex}>
                      <td id="bottomborder"><strong>{schedule.tokenNumber}</strong></td>
                      <td id="bottomborder" className="text-left">
                        {schedule.postPrefList.map((post, index) => (
                          <span key={index}>{post} </span>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {getInterviewPostPreferenceList && getInterviewPostPreferenceList.postCriteriaList && (
                <table className="table table-bordered text-center">
                  <tbody>
                    {getInterviewPostPreferenceList.postCriteriaList.map((item, index) => (
                      <tr key={index}>
                        <td className="custom-bg-light bold-label small-font w-100px">{item.abbreviation}</td>
                        <td className="text-left">{item.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default InterviewPostPreferencesList;
